import React from 'react';
import FlowComponent from '../components/FlowComponent';
import { useParams } from 'react-router-dom';

const FlowPage = () => {
  const { id } = useParams();
  const mode = window.location.pathname.includes('/view/') ? 'view' : 'edit'; // Mode'u belirle

  return (
    <div
      style={
        mode === 'view'
          ? {
              padding: 0,
              margin: 0,
              height: '100vh',
              width: '100vw',
              overflow: 'hidden',
            }
          : {}
      }
    >
      <FlowComponent mode={mode} />
    </div>
  );
};

export default FlowPage;
